import { ViewOption } from "types/viewOptions";

interface AdListViewSelectorProps {
    viewType: ViewOption;
    handleViewChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
}

export default function AdListViewSelector({ viewType, handleViewChange }: AdListViewSelectorProps) {
    return (
        <div className="d-flex align-items-center">
                <label htmlFor="sortSelect" className="me-2 text-nowrap">Görünüm:</label>
                <select 
                  id="viewSelect" 
                  className="form-select form-select-sm" 
                  value={viewType}
                  onChange={handleViewChange}
                >
                  <option value={ViewOption.GRID}>Kartlar</option>
                  <option value={ViewOption.LIST}>Liste</option>
                </select>
              </div>
    )
}